var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{attrs:{"dense":"","outlined":"","label":_vm.label,"rules":_vm.rules,"color":_vm.color},model:{value:(_vm.sehirInput),callback:function ($$v) {_vm.sehirInput=$$v},expression:"sehirInput"}})
}
var staticRenderFns = []

export { render, staticRenderFns }